// extracted by mini-css-extract-plugin
export default {"onboarding_tooltip":"onboarding_tooltip___I4FjO","content":"content___kNVIb"};